// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32ox4","type":"styles_type__3JjOS","choices":"styles_choices__SckVe"};